import { combineReducers } from 'redux'
import { portfoliosReducer } from './reducers/portfolios'
import { userReducer } from './reducers/user'
import {portfolioReducer} from './reducers/portfolio'
import {importReducer} from './reducers/import'
import {profileReducer} from './reducers/profile'
import {transactionReducer} from "./reducers/transaction";

export const rootReducer = combineReducers({
  portfolios: portfoliosReducer,
  portfolio: portfolioReducer,
  user: userReducer,
  import: importReducer,
  profile: profileReducer,
  transaction: transactionReducer,
});